/**
 * Created by dx.yang on 2016/10/25.
 */

import Vue from 'vue';


// 兼容写法 获取和设置光标位置
function doGetCaretPosition (oField) {

    var iCaretPos = 0;
    //IE support
    if (document.selection) {

        oField.focus();
        var oSel = document.selection.createRange();

        oSel.moveStart('character', -oField.value.length);

        iCaretPos = oSel.text.length;
    }
    //MOZILLA and others
    else if (oField.selectionStart || oField.selectionStart == '0')
        iCaretPos = oField.selectionStart;

    return iCaretPos;
}

function setCaretPosition(ctrl,pos) {
    if (ctrl.setSelectionRange) {
        ctrl.focus();
        ctrl.setSelectionRange(pos,pos);
    }
    else if (ctrl.createTextRange) {
        var range = ctrl.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
    }
}

export default Vue.extend({
    name: 'KsIpInput',
    props: {
        value: {
            // type: String,
            required: false,
            default: '0.0.0.0'
        },
        disable0: {
            type: Boolean,
            required: false,
            default: false
        },
        disable1: {
            type: Boolean,
            required: false,
            default: false
        },
        disable2: {
            type: Boolean,
            required: false,
            default: false
        },
        disable3: {
            type: Boolean,
            required: false,
            default: false
        },
        autoIp: {
            type: Boolean,
            required: false,
            default: false
        },
        tipMsg: {
            type: String,
            required: false,
            default: Vue.$trans(`自动`)
        }
    },
    watch: {
        value() {
            var me = this;
            var ip = me.value;
            ip = ip.split('.');
            me.theIp.pos_0 = ip[0];
            me.theIp.pos_1 = ip[1];
            me.theIp.pos_2 = ip[2];
            me.theIp.pos_3 = ip[3];
        },
        theIp: {
            deep: true,
            handler() {
                var me = this;
                me.$nextTick(() => {
                _.forEach(me.theIp, (v, k) => {
                    if (v === undefined || v===null) {
                        return
                    }
                    if (v.indexOf('.') != -1) {
                        v = v.replace('.', '')
                    }

                    if (v === '') {
                        return
                    }

                    if (v.length > 3) {
                        me.theIp[k] = v.slice(0, 3)
                    }
                    v = v * 1;

                    if (isNaN(v)) {
                        me.theIp[k] = '0';
                    } else if (v < 0) {
                        me.theIp[k] = '0';
                    } else if (v > 255) {
                        me.theIp[k] = '255';
                    } else if (v + '' != me.theIp[k]) {
                        me.theIp[k] = v + '';
                    }
                });
                var tem = `${me.theIp['pos_' + 0]}.${me.theIp['pos_' + 1]}.${me.theIp['pos_' + 2]}.${me.theIp['pos_' + 3]}`;
                    if (tem != me.value) {
                        // me.value = tem;
                        me.$emit('input', tem);
                    };
                })
            }
        },
        'theIp.pos_0': function() {
            var me = this;
            if (me.theIp.pos_0 === null || me.theIp.pos_0 === undefined) {
                return
            }
            if (me.theIp.pos_0.length == 3) {
                var input = $(me.$el).find('.pos-0').get(0);
                var p = doGetCaretPosition(input);
                if (p === 3) {
                    $(me.$el).find('.pos-1').focus().select();
                }
            }
        },
        'theIp.pos_1': function() {
            var me = this;
            if (me.theIp.pos_1 === null || me.theIp.pos_1 === undefined) {
                return
            }
            if (me.theIp.pos_1.length == 3) {
                var input = $(me.$el).find('.pos-1').get(0);
                var p = doGetCaretPosition(input);
                if (p === 3) {
                    $(me.$el).find('.pos-2').focus().select();
                }
            }
        },
        'theIp.pos_2': function() {
            var me = this;
            if (me.theIp.pos_2 === null || me.theIp.pos_2 === undefined) {
                return
            }
            if (me.theIp.pos_2.length == 3) {
                var input = $(me.$el).find('.pos-2').get(0);
                var p = doGetCaretPosition(input);
                if (p === 3) {
                    $(me.$el).find('.pos-3').focus().select();
                }
            }
        },
    },
    data() {
        return {
            theIp: {
                pos_0: '0',
                pos_1: '0',
                pos_2: '0',
                pos_3: '0'
            }
        };
    },
    created() {
        var me = this;
        var ip = me.value;
        ip = ip.split('.');
        me.theIp.pos_0 = ip[0];
        me.theIp.pos_1 = ip[1];
        me.theIp.pos_2 = ip[2];
        me.theIp.pos_3 = ip[3];
    },
    mounted() {
        var me = this;

        me.$nextTick(() => {

            $(me.$el).on('focus', 'input', function() {
                var el = this;
                setTimeout(function() {
                    var p = doGetCaretPosition(el);
                    $(el).data('last-pos', p)
                }, 0);
            }).on('keyup', 'input', function(e) {
                var el = $(this);
                var idx = el.data('index');
                var lastPos = el.data('last-pos');
                var p = doGetCaretPosition(this);
                if (e.keyCode === 37) {
                    if (idx != 0) {
                        if (lastPos === 0 && p === 0) {
                            var target = $(me.$el).find(`.pos-${idx-1}`);
                            var value = me.theIp[`pos_${idx - 1}`];
                            var len = value.length;
                            setCaretPosition(target.get(0), len);
                        }
                    }
                } else if (e.keyCode === 39) {
                    var curValue = me.theIp[`pos_${idx}`];
                    var curValueSize = curValue.length;
                    if (idx !== 3) {
                        if (p === curValueSize && lastPos === curValueSize) {
                            var target = $(me.$el).find(`.pos-${idx+1}`);
                            setCaretPosition(target.get(0), 0)
                        }
                    }
                } else if (e.keyCode === 8) {
                    if (idx != 0) {
                        if (lastPos === 0 && p === 0) {
                            var target = $(me.$el).find(`.pos-${idx-1}`);
                            var value = me.theIp[`pos_${idx - 1}`];
                            var len = value.length;
                            setCaretPosition(target.get(0), len);
                        }
                    }
                }
                el.data('last-pos', p)
            })
        });


    },

    destroy() {
        var me = this;
        $(me.$el).off('focus', 'input').off('keyup', 'input');
    },

    methods: {
        onPaste(e) {
            var clipText = '';
            if(window.clipboardData){
                clipText = window.clipboardData.getData('Text');
            }else if(typeof e == 'object' && e.clipboardData){
                clipText = e.clipboardData.getData('text/plain');
            }
            clipText = clipText.split('.');
            if (clipText.length === 4) {
                this.theIp.pos_0 = clipText[0];
                this.theIp.pos_1 = clipText[1];
                this.theIp.pos_2 = clipText[2];
                this.theIp.pos_3 = clipText[3];
                e.preventDefault()
                return false;
            }
        }
    }
});
